<!-- Search Bar -->
<div class="position-relative mb-3">
  <mat-icon class="search-icon text-secondary">search</mat-icon>
  <input
    type="text"
    class="form-control search-input"
    placeholder="Search games..."
    [ngModel]="searchTerm()"
    (ngModelChange)="searchTerm.set($event)">
</div>

<!-- Selection Summary -->
<div class="p-3 bg-light rounded mb-3">
  <div class="d-flex justify-content-between align-items-center">
    <span>
      <strong>{{ selectedCount() }}</strong> game{{ selectedCount() !== 1 ? 's' : '' }} selected
    </span>
    <button mat-button
            type="button"
            (click)="onSelectAll()"
            class="text-primary fw-medium">
      {{ allFilteredSelected() ? 'Deselect' : 'Select' }} All
    </button>
  </div>
</div>

<!-- Games List -->
<div class="games-list border rounded overflow-auto">
  @if (isLoading()) {
    <div class="d-flex flex-column align-items-center justify-content-center p-4 text-secondary">
      <mat-icon class="large-icon mb-2">hourglass_empty</mat-icon>
      <p class="mb-0">Loading games...</p>
    </div>
  } @else if (filteredGameSelections().length === 0) {
    <div class="d-flex flex-column align-items-center justify-content-center p-4 text-secondary">
      <mat-icon class="large-icon mb-2">search_off</mat-icon>
      <p class="mb-0">No games found matching "{{ searchTerm() }}"</p>
    </div>
  } @else {
    @for (gameSelection of filteredGameSelections(); track gameSelection.game.Id; let last = $last) {
      <div class="game-item py-2 px-3" [ngClass]="{ 'border-bottom': !last, 'selected': gameSelection.selected }">
        <mat-checkbox
          [checked]="gameSelection.selected"
          (change)="onGameSelectionChange(gameSelection.game.Id, $event.checked)"
          class="game-checkbox">
          <div class="ms-2">
            <div class="fw-medium">{{ gameSelection.game.Name }}</div>
            <div class="small text-secondary">{{ gameSelection.game.Subdomain }}</div>
          </div>
        </mat-checkbox>
      </div>
    }
  }
</div>
